import Decimal from "decimal.js";
import { ExamInfo } from "../interfaces/reserve-loading.model";

  // 三寶項目
  export const THREE_BAO_ITEMS: Array<ExamInfo> = [
    {
      examItem: 'F0000034',
      examName: '午餐',
      examPrice: new Decimal(400),
      examMemo: '',
      examType: '加值服務',
      deptName: '其他',
    },
    {
      examItem: 'H0000003',
      examName: '健檢服裝',
      examPrice: new Decimal(555),
      examMemo: '',
      examType: '加值服務',
      deptName: '其他',
    },
    {
      examItem: 'NC000109',
      examName: '報告諮詢',
      examPrice: new Decimal(1000),
      examMemo: '專科醫師一對一報告諮詢',
      examType: '加值服務',
      deptName: '其他',
    }
  ];